import { render } from "./BeneficiosPage.vue?vue&type=template&id=99c8e66a"
import script from "./BeneficiosPage.vue?vue&type=script&lang=js"
export * from "./BeneficiosPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__